// extracted by mini-css-extract-plugin
export var billingAddress = "_xr-g";
export var contactInfo = "_xr-d";
export var customerInfoContainer = "_xr-c";
export var customerInfoContainerMobile = "_xr-h";
export var customerInfoRow = "_xr-a";
export var customerInfoSection = "_xr-b";
export var fullWidthDividerMobile = "_xr-i";
export var imageContainer = "_xr-1";
export var paymentMethod = "_xr-e";
export var priceText = "_xr-6";
export var priceTextMobile = "_xr-7";
export var product = "_xr-0";
export var productImage = "_xr-2";
export var productInfo = "_xr-4";
export var productMobile = "_xr-9";
export var productTitle = "_xr-8";
export var quantityBadge = "_xr-3";
export var quantityText = "_xr-5";
export var shippingAddress = "_xr-f";